import Placeholders from './Placeholders';

export { type PlaceholdersProps } from './Placeholders';
export default Placeholders;
